import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import type { SelectVigboAlbumPopupProps } from 'reactApp/ui/SelectVigboAlbumPopup/SelectVigboAlbumPopup';

export const openSelectVigboAlbumPopup = (data: SelectVigboAlbumPopupProps) =>
    openPopupHelper<SelectVigboAlbumPopupProps>({
        popupName: popupNames.SELECT_VIGBO_ALBUM,
        data,
    });

export const closeSelectVigboAlbumPopup = () => closePopupHelper(popupNames.SELECT_VIGBO_ALBUM);
